import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

import { DrawerPageComponent } from './drawer-page.component';

@NgModule({
    imports: [
        CommonModule,
        TranslateModule.forChild()
    ],
    declarations: [
        DrawerPageComponent
    ],
    exports: [
        DrawerPageComponent
    ]
})
export class DrawerPageModule { }
